export const GROWTH_LEADS_META = {
  eyebrow: 'Google Ads · Lead Tracking',
  titleLead: 'Patient',
  titleAccent: 'leads',
  description:
    'Every person who contacted your practice through a Google Ad — tracked from first click to completed treatment.',
  periodLabel: 'April 2026',
  footerNote:
    'Leads matched to appointments via PMS integration · revenue tracked from completed treatments',
} as const;
